module.exports = __webpack_public_path__ + "img/11825391_L.f6f28017.png";